import Modal from 'ds/components/modal';
import React from 'react';
import { HostedFieldsProps, TranzilaModalType } from './types';
import { BackIconWrapper, Wrapper } from './styled';
import PaymentForm from './Form';
import { useLocale } from 'locale';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { PaymentMethod } from 'store/state/app';
import { logAndTrackError } from 'helpers/jstracking';
import { useABTests } from 'hooks/useABTests';
import { TranzilaGPayLastCheck } from 'config/abTests';
import ArrowBack from 'assets/svg/arr-back-black.svg';


type CardInfo = Pick<HostedFieldsProps, 'toggleModal' | 'handshakeState' | 'onPaymentSubmit' | 'fieldsErrorState' | 'setModal' | 'modalState'>;

export const CardInfoModal: React.FC<CardInfo> = ({
  toggleModal,
  handshakeState,
  onPaymentSubmit,
  fieldsErrorState,
  setModal,
  modalState,
}) => {
  const { t } = useLocale();
  const { tranzilaGPayLastCheck } = useABTests();
  const isGPayMode = tranzilaGPayLastCheck === TranzilaGPayLastCheck.modeB;
  const screen = useScreenBreakpoint();
  const isDesktop = screen >= 3;

  const { credit_card_number: cardError, card_holder_id_number: holderError, cvv, expiry } = fieldsErrorState;
  const paymentData = handshakeState && handshakeState.data && handshakeState.data.initHostedFieldsPayment;

  const { paymentId, amount } = paymentData || {};

  const handleSubmit = () => {
    if (paymentId) {
      onPaymentSubmit({ method: PaymentMethod.CARD, paymentId });
    }
    else {
      logAndTrackError('HOSTED FIELDS: Failed payment', 'No payment ID');
    }
  };

  const closeModal = () => {
    toggleModal(null);
  };

  const handleBackClick = () => {
    setModal({
      planInfo: modalState.planInfo,
      modalType: TranzilaModalType.MethodInitiation,
      paymentDealType: modalState.paymentDealType,
      bulletinId: modalState.bulletinId || undefined,
    });
  };

  return (
    <Modal
      isOpen
      onClose={closeModal}
      title={t('tranzila.hostedFields.form.title')}
      isFullWidthMainContent
      mobileModalPositionBottom
      desktopModalPositionCenter
      contentWrapperStyle={{
        borderRadius: isDesktop ? 24 : '16px 16px 0 0',
        padding: 0,
      }}
      headerStyle={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: 58,
        borderBottom: '1px solid #ececec',
        fontSize: '15px',
        lineHeight: '15px',
      }}
      closeButtonStyle={{
        position: 'absolute',
        left: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 40,
        height: 40,
      }}
      titleStyle={{
        margin: 0,
      }}
    >
      <Wrapper isGPayMode={isGPayMode}>
        {isGPayMode ? (
          <BackIconWrapper onClick={handleBackClick}>
            <ArrowBack />
          </BackIconWrapper>
        ) : null}
        <div className="payment-card">
          <PaymentForm
            handleSubmit={handleSubmit}
            cardError={cardError}
            cvvError={cvv}
            dateError={expiry}
            amount={amount}
            holderError={holderError}
          />
        </div>
      </Wrapper>
    </Modal>
  );
};
